window.MenuHoverTimer = 300; //Menu hover delay time (ms)
window.MenuId = 0; //Menu hover delay time (ms)

//////Layout use Header script start--------------------------------
//設定所有menu 相關內容


var SettingMenu = function() {
	browserHandler();
	SettingMenuBarHeight(); //設定menu header 至頂高度

	//顯示大版Menu
	settingMenuLevel1();
	settingMenuLevel2();
	settingScrollTopMenu();

	//顯示小版Menu
	SettingMobileMenu();
	SettingSearch();

	scrollMobileMenu();
	//settingMenuB2BCookie();
	settingMenuB2BRwdPadding();
	//MWC2020Menu();
	changeMenuTypeConsumerImage();
    changeMenuTypeEnterpriseMenuLevel4();
    changeMenuTypeSolutionMenuLevel4();
    settingMenuTypeConsumerContent();
};

var settingMenuB2BRwdPadding = function() {
	if (window.isB2bWhiteStyle) {
		var checkDiv = $(".content_padding");
		if (checkDiv) {
			var paddingTop = "inherit";
			var firstSunMenu = $('*[class^="subTitle_"]').first();
			if (firstSunMenu) {
				if ($("#header-bar") && CheckUseRWDsizeNow()) {
					paddingTop = parseInt($("#header-bar").height());
				}
			}
			firstSunMenu.css("padding-top", paddingTop);
		}
	}
};

//var settingMenuB2BCookie = function() {
//	var code = CookieWithCountryCode.get("country_code_now", "global");
//	if (code !== window.CountryCode && window.isB2B === "False") {
//		CookieWithCountryCode.set("country_code_now", window.CountryCode, "true", "", "global", ".gigabyte.com");
//	}

//};

var CheckMenuUrl = function() {
	var menuTitleLink = $("ul.menu-title-area").find("li.menuTitle").find("a.menuTitleHref");
	var dataName = "data-pclink";
	if (CheckUseRWDsizeNow()) {
		dataName = "data-mobilelink";
	}
	var length = menuTitleLink.length;
	for (var i = 0; i < length; i++) {
		var item = menuTitleLink.eq(i);
		item.attr("href", item.attr(dataName));
	}
};

var scrollMobileMenu = function() {
	$(window).scroll(function(event) {
		var scroll = $(window).scrollTop();
		if (scroll === 0) {
			$("#header-bar").removeClass("scrolling");
			
			if ($("#header-bar").hasClass("NotCoverHeader")) {
				$("#PageMainContent").removeClass("header-scrolling");
			}

			// 20210916 移除 policy 用 scrolling class 控制 小版隱藏行為
			//$("#policy-div").removeClass("scrolling");
		} else {
			if (!$("#header-bar").hasClass("scrolling")) {
				$("#header-bar").addClass("scrolling");
				$(window).trigger("resize");
				if ($("#header-bar").hasClass("NotCoverHeader")) {
					$("#PageMainContent").addClass("header-scrolling");
				}
				// 20210916 移除 policy 用 scrolling class 控制 小版隱藏行為
				//$("#policy-div").addClass("scrolling");
			}
		}
	});
};

var SettingMenuBarHeight = function() {

	if (CheckWebsiteUnder960()) {
		var logoHeight = 60;
		var windowHeight = $(window).height();
		if (windowHeight < $("#header-bar").height()) {
			windowHeight = $("#header-bar").height();
		}
		var policyHeight = 0;
		if (!$("#policy-div").hasClass("scrolling")) {
			policyHeight = $("#policy-div").height();
		}
		$("#header-bar").find(".content-other").height(logoHeight);
		//$("#header-bar").css("max-height", $(window).height() - (policyHeight));
		$("#header-bar").css("height", "");
		$("#header-bar").find(".menu-level-1, .content-menu").css("height", "");
		$("#header-bar").find(".menu-level-1, .content-menu")
			.css("min-height", windowHeight - logoHeight - (policyHeight));
		$("#header-bar").find("#mobileMenuShowBodyBlock").css("min-height", windowHeight - logoHeight);
		$("#header-bar").find("#recentlySearch").css("min-height", windowHeight - logoHeight);
		$(".MenuAutocompleteRwd").height(windowHeight - logoHeight);
		$("#recentlySearch").css("top", "");

	} else {
		var logoIconHeight = CheckUseRWDsizeNow(1024)
			? 50
			: $("#header-bar").find(".content-logo").find("img").height() * 3;

		if ($("#header-bar").hasClass("b2bMenu")) {
			//logoiconHeight = $("#header-bar").find(".content-logo").height();
		}
		//$("#header-bar").css("max-height", "");
		if (logoIconHeight > 0) {
			//當 Header 高度需減掉Border-bottom，避免算出有藍色Email按鈕時，Border突出導致藍色按鈕區塊凹進去跑版
			var headerBarBorderBottom = parseInt($("#header-bar").css("border-bottom-width"));
			$("#header-bar").height(logoIconHeight - headerBarBorderBottom);
			$("#header-bar").find(".menu-level-1, .content-menu").height(logoIconHeight);
			$("#header-bar").find(".content-menu").css("line-height", logoIconHeight + "px");
			//避免menu 上方存在其他物件高度
			var menuTopPosition = $("#header-bar").offset().top;
			//			console.log(logoIconHeight);
			//			console.log(menuTopPosition);
			$("#pcMenuShowBlock").css("top", logoIconHeight);
			$("#header-bar").find(".menu-level-1, .content-menu").css("min-height", "");

			$("#recentlySearch").css("top", logoIconHeight);
			$("#header-bar").find(".content-other").height(logoIconHeight);
		}

	}
	$("#policy-close").off("click").on("click",
		function() {
			setTimeout(function() {
					SettingMenuBarHeight();
				},
				500);
		});
	//For Solution Content page
	var contentTopArea = $(".Content-TopArea");
	if (contentTopArea) {
		if ($(".Solutions-Content").length) {
			if (!CheckUseRWDsizeNow(960)) {
				var height = $(window).height() - $("#header-bar").height();
				contentTopArea.css("height", height);
			} else {
				contentTopArea.css("height", "inherit");
			}
		}
	}
};

var SentdMenuGa = function (action, name, url) {
	return false;
	var actionname = action + "-[" + name + "]";
	var Category = "Top-Menu";
	SendGaEvent(Category, actionname, url);
};
window.MenuOpen = "";


////////// 以下為小版處理 /////////////////////////////////////////////////////////

var SettingMobileMenu = function() {
	//setting mobile menu
	var mobileMenu = $("#mobile-menu");
	//Click Level 1
	mobileMenu.on("click",
		function() {
			checkMobileMenu($(this));
		});
	//Click Level 2
	var titleHasChild = $("#header-bar").find("li.menuTitle");
	titleHasChild.on("click",
		function() {
			var that = $(this);
			var hasChild = (that.attr("data-haschild") === "true");
			if (hasChild) {
				showMobileMenu(that);
			}

		});
};

var setMenuFadeOutButton = function() {
	$(".mobileMenuFadeOutButton ,.listNext").off("click").click(function() {
		var childMenu = $(this).parent(".titleContainer").nextAll(".mobileMenuFadeOutArea");
		var icon = $(this).parent(".titleContainer").find("svg");
		if (childMenu.css("display") === "none") {
			childMenu.slideDown(300,
				"easeInOutCirc",
				function() {
					icon.addClass("RotationVertical");
				});
		} else {
			childMenu.slideUp(300,
				"easeInOutCirc",
				function() {
					icon.removeClass("RotationVertical");
				});
		}
	});
};

//舊版-mobile start
var checkMobileMenu = function(that) {
	setMenuFadeOutButton();
	that.addClass("useTransition");
	if (that.hasClass("showClose")) {
		//點擊叉叉
		$("#full-search-keyword").attr("placeholder", $("#full-search-keyword").attr("data-word"));
		that.removeClass("showClose");
		MobilelockBodyScroll("unlock");
		var callback = function() {
			$("#header-bar").removeClass("openMobile");
			$("#mobileMenuShowBlock").removeClass("open");
			setTimeout(function() {
					that.removeClass("useTransition");
					var mobileMenuShowBodyArea = $("#mobileMenuShowBodyBlock");
					mobileMenuShowBodyArea.removeClass("showBody");
					$(".mobileBtmMenuBack").removeClass("showOpacity");
					$("#header-bar").find(".content-menu").removeClass("showBody");
					$("#mobileMenuShowBodyBlock").find(".backMainPage").removeClass("show");
					$("#PageMainContentBlock").removeClass("whiteBg");
					$("#policy-div").removeClass("showMobileMenu");
					window.mobileBlockOpen = false;
				},
				300);
		};
		clearMenuSearch();
		setMobileMenuAnimation("close", callback);
	} else {
		//點擊漢堡
		$("#full-search-keyword").attr("placeholder",
			$("#full-search-keyword").attr("data-word") + " " + $("#full-search-keyword").attr("data-icon"));
		that.addClass("showClose");
		autoCompleteMenuSearch();
		var callback = function() {
			$("#header-bar").addClass("openMobile");
			MobilelockBodyScroll("lock");
			setTimeout(function() { that.removeClass("useTransition"); }, 300);
			$("#policy-div").addClass("showMobileMenu");
			window.mobileBlockOpen = true;
		};
		setMobileMenuAnimation("open", callback);

	}
};
window.mobileBlockOpen = false;
window.touchScroll = false;

var backMainMenu = function() {
	var callback = function() {
		var mobileMenuShowBodyArea = $("#mobileMenuShowBodyBlock");
		mobileMenuShowBodyArea.removeClass("showBody");
		$(".mobileBtmMenuBack").removeClass("showOpacity");
		$("#header-bar").find(".content-menu").removeClass("showBody");
		$("#mobileMenuShowBodyBlock").find(".backMainPage").removeClass("show");
		$("#PageMainContentBlock").removeClass("whiteBg");
	};
	setMobileMenuAnimation("closeMenuBody", callback);
};

var setMobileMenuAnimation = function(type, callBack) {
	var animationTime = 200;
	var fakeMenuBg = $("#mobileMenuShowBlock");
	var contentMenu = $("#header-bar").find("ul.content-menu");
	var mobileMenuBody = $("#mobileMenuShowBodyBlock");
	switch (type) {
	case "open":
		var startAnimatPos = "-100%";
		var EndAnimatPos = "0";
		if (window.isRTL) {
			startAnimatPos = "200%";
			EndAnimatPos = "0";
		}
		fakeMenuBg.css("left", startAnimatPos);
		contentMenu.css("left", startAnimatPos);
		fakeMenuBg.addClass("open");
		fakeMenuBg.add(contentMenu).animate({
				left: EndAnimatPos,
			},
			animationTime,
			function() {
				callBack();
				fakeMenuBg.css("left", "");
				$("#header-bar").addClass("done");
				fakeMenuBg.removeClass("open");
				contentMenu.css("left", "");
				if (window.isB2B) {
					var that = $(".content-menu").find("li.menuTitle[data-isb2b='true']");
					var hasChild = (that.attr("data-haschild") === "true");
					if (hasChild && that.length ===1 ) {
						showMobileMenu(that);
					}
				}
			});
		break;
	case "close":
		var EndAnimatPos = "-100%";
		if (window.isRTL) {
			EndAnimatPos = "200%";
		}
		fakeMenuBg.addClass("open");
		$("#header-bar").removeClass("done");
		fakeMenuBg.add(contentMenu).animate({
				left: EndAnimatPos,
			},
			animationTime,
			function() {
				callBack();
				fakeMenuBg.css("left", "");
				fakeMenuBg.removeClass("open");
				contentMenu.css("left", "");
			});
		break;
	case "showMenuBody":
		mobileMenuBody.css("left", "100%");
		mobileMenuBody.css("display", "block");
		mobileMenuBody.animate({
				left: "0%",
			},
			animationTime,
			function() {
				callBack();
				mobileMenuBody.css("left", "");
				mobileMenuBody.css("display", "");
			});
		break;
	case "closeMenuBody":
		mobileMenuBody.css("left", "0%");
		contentMenu.css("display", "block");
		mobileMenuBody.animate({
				left: "100%",
			},
			animationTime,
			function() {
				callBack();
				mobileMenuBody.css("left", "");
				contentMenu.css("display", "");
			});
		break;
	}

};

//舊版-mobile end

var settingSearchGaEvent = function () {
	return false;
	$("#Top-Menu-Search").submit(function() {
		SendGaEvent("Top-Menu",
			"Searchbar-SearchWord:" + $("#full-search-keyword").val(),
			location.pathname + location.search);
	});
};

var SettingSearch = function() {
	var searchIcon = $("#header-bar").find(".content-other").find(".search_icon");
	var closeSearch = $("#header-bar").find(".content-other").find("#Top-Menu-Search").find(".close");
	searchIcon.add(closeSearch).on("click",
        function () {
			ToogleSearch();
			$("#full-search-keyword").attr("placeholder", $("#full-search-keyword").attr("data-word"));
		});
	$("#PageMainContentBlock").on("click",
		function() {
			if ($("#header-bar").hasClass("opensearch")) {
				ToogleSearch();
			}
		});
	$("#full-search-keyword").on("click",
		function() {
			$("#Top-Menu-Search").addClass("active");
		});
	$("#full-search-keyword").on("blur",
		function() {
			$("#Top-Menu-Search").removeClass("active");
		});
	$("#full-search-keyword").on("keyup",
		function () {
			checkSearWordToClear();
		});
	$("#Top-Menu-Search").find("span.clear").on("click",
		function() {
			clearMenuSearch();
		});
};
var ToogleSearch = function() {
	var animationTime = 200;
	var functionObj = function(openSearch) {
		$("#Top-Menu-Search").find(".content").css("display", "");
        if (openSearch) {
			$("#full-search-keyword").trigger("focus");
		}
		$("#header-bar").addClass("done");
		$("#policy-div").addClass("showSearch");
	};
	var startFunctionObj = function() {

	};
	var leftStartpos = "100%";
	var leftEndpos = "0%";
	var headerBar = $("#header-bar");
	var startWidth = "20px";
	var EndWidth = "100%";
	var openSearch = false;
	if (!headerBar.hasClass("opensearch")) {
		openSearch = true;
		startFunctionObj = function() {
			$("#Top-Menu-Search").find(".content").css("display", "none");
			$("body").addClass("showSearch");
			headerBar.addClass("opensearch");
			autoCompleteMenuSearch();
			GetRecentlySearchItem();
			$("#PageMainContentBlock").addClass("whiteBg");
		};
		if (window.isRTL) {
			leftStartpos = "-100%";
			leftEndpos = "0%";
		}
		window.mobileBlockOpen = true;
		//打開search icon 送ga
		//SendGaEvent("Top-Menu", "opensearch", location.pathname + location.search);
	} else {
		leftStartpos = "0%";
		leftEndpos = "100%";
		startWidth = "100%";
		EndWidth = "20px";
		if (window.isRTL) {
			leftEndpos = "-100%";
		}
        functionObj = function (openSearch) {
			headerBar.removeClass("opensearch");
			$("#Top-Menu-Search").find(".content").css("display", "");
			$("#header-bar").removeClass("done");
			clearMenuSearch();
			$("#recentlySearchWord").removeClass("show");
			$("#recentlySearch").removeClass("show");
			$("body").removeClass("showSearch");
			$("#PageMainContentBlock").removeClass("whiteBg");
            $("#policy-div").removeClass("showSearch");
            if (openSearch) {
                $("#full-search-keyword").trigger("focus");
            }
		};
		window.mobileBlockOpen = false;
		//關閉search icon 送ga
		//SendGaEvent("Top-Menu", "closesearch", location.pathname + location.search);
	}
	if (CheckUseRWDsizeNow()) {
		$("#header-bar").css("left", leftStartpos);
		startFunctionObj();
		var scrollType = "lock";
		if (!openSearch) {
			scrollType = "unlock";
			MobilelockBodyScroll(scrollType);
		}
		$("#header-bar").animate({
				left: leftEndpos,
			},
			animationTime,
			function() {
				MobilelockBodyScroll(scrollType);
				functionObj(openSearch);
				if (!openSearch) {
					//避免Trigger 事件造成 其他 JS 套件失效
					if ($("#top_banner").length || $(".MenuHaveRWDSlider").length) {
						$(window).trigger("resize");
					}
				}
				$("#header-bar").css("left", "");
			});
	} else {
		startFunctionObj();
		$("#Top-Menu-Search").addClass("animating");
		$("#Top-Menu-Search").find("div.content").css("width", startWidth);
		$("#Top-Menu-Search").find(".content").css("display", "block");
		var pos = "right";
		if (window.isRTL) {
			pos = "left";
		}
		$("#Top-Menu-Search").find(".content").css("float", pos);
		if (!window.isB2bWhiteStyle) {
			$("#header-bar").css("float", pos);
		}

		/*$("#header-bar").animate({
		    width: EndWidth
		}, function() {
		    $("#header-bar").css("width", "");
		    $("#header-bar").css("float", "");
		});*/
		$("#Top-Menu-Search").find(".content").animate({
				width: EndWidth
			},
			function() {
                functionObj(openSearch);
				$("#Top-Menu-Search").removeClass("animating");
				$("#Top-Menu-Search").find("div.content").css("width", "");
				$("#Top-Menu-Search").find(".content").css("display", "");
				$("#Top-Menu-Search").find(".content").css("float", "");
			});
		//functionObj();
	}

};
var checkSearWordToClear = function() {
	var val = $("#full-search-keyword").val();
	var clear = $("#Top-Menu-Search").find("span.clear");
	if (val.length > 0) {
		$("#full-search-keyword").addClass("notEmpty");
		clear.addClass("show");
	} else {
		$("#full-search-keyword").removeClass("notEmpty");
		clear.removeClass("show");
	}
};
var clearMenuSearch = function() {
	$("#full-search-keyword").val("");
	checkSearWordToClear();
};

//autocomplete menu search start
var autoCompleteMenuSearch = function() {
	//Auto Complete

	var ajaxUrl_GetProductNameNeedSearchOtherColumn = String.format(window.mainFileUploadPath.Ajax + "{0}",
		"/SearchFunction/GetProductName?limit=10&needSearchOtherColumn=true");
	var autoCompleteClass = "MenuAutocomplete";
	$.widget("custom.catcomplete",
		$.ui.autocomplete,
		{
			_create: function() {
				this._super();
				this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
			},
			_renderMenu: function(ul, items) {
				var that = this,
					currentCategory = "";
				$.each(items,
					function(index, item) {
						var li;
						if (item.category != currentCategory) {
							ul.append("<li class='ui-autocomplete-category'><div class='categoryTitle'>" +
								item.category +
								"</div></li>");
							currentCategory = item.category;
						}
						li = that._renderItemData(ul, item);
						if (item.category) {
							li.attr("aria-label", item.category + " : " + item.label);
						}
					});
			}
		});
	$("#full-search-keyword").off("catcomplete").catcomplete({
		source: function(request, response) {
			//$.getJSON('/Ajax/SearchFunction/GetProductName?limit=10&needSearchOtherColumn=true',
			$.getJSON(ajaxUrl_GetProductNameNeedSearchOtherColumn,
				{ term: encodeURI(request.term.toString()) },
				function(data) {
					response(data.SearchDatas);
					fixLtRonRTLForSearch("full-search-keyword");
				});
		},
		minLength: 3, //限制搜尋字元
		//delay: 10,//控制按鍵後的反應，預設是 400 msec (0.4 秒)
		classes: {
			"ui-autocomplete": autoCompleteClass
		},
		select: function(event, ui) {
			//var url = '/' + ui.item.ck + '/' + ui.item.url;
			var url = String.format("{0}/{1}/{2}", window.UrlCountryCode, ui.item.ck, ui.item.url);
			if (ui.item.url.toLowerCase().indexOf("/support/faq") >= 0) {
				url = ui.item.url;
				//SendGaEvent("Top-Menu", "Searchbar-Select-Faq-Url:" + url, location.pathname + location.search);
			} else {
				//SendGaEvent("Top-Menu", "Searchbar-Select-Model-Url:" + url, location.pathname + location.search);
			}
			setRecentlySearch(ui.item.value);
			window.location.href = url;
		},
		open: function(event, ui) {
			var autocompleteArea = $("." + autoCompleteClass);
			//autocompleteArea.addClass("google-font");
			if ($("div.topBg").hasClass("Rwd")) {
				autocompleteArea.addClass(autoCompleteClass + "Rwd");
			}
			if ($("div.topBg").hasClass("RTL")) {
				autocompleteArea.addClass("RTL");
			}
			if ($("#header-bar").hasClass("openMobile")) {
				autocompleteArea.addClass("openMobile");
			}
			if (window.isRTL) {
				autocompleteArea.addClass("RTL");
			}
			if (autocompleteArea.find("li").length > 0) {
				autocompleteArea.css("top", $("#header-bar").height() + $("#header-bar").offset().top);
				$("#header-bar").find(".content-menu").addClass("showAutoComplete");
				$("#mobileMenuShowBodyBlock").addClass("showAutoComplete");
				$("#recentlySearchWord").addClass("showAutoComplete");
				$("#recentlySearch").addClass("showAutoComplete");
			}
			if (CheckUseRWDsizeNow()) {
				autocompleteArea.height($(window).height() - $("#header-bar").find(".content-other").outerHeight());
				if ($("#header-bar").hasClass("openMobile")) {
					autocompleteArea.addClass("openMobile");
					autocompleteArea.removeClass("opensearch");
				} else if ($("#header-bar").hasClass("opensearch")) {
					autocompleteArea.addClass("opensearch");
					autocompleteArea.removeClass("openMobile");
				}

			} else {
				autocompleteArea.css("height", "");
			}

		},
		close: function(event, ui) {
			$("#header-bar").find(".content-menu").removeClass("showAutoComplete");
			$("#mobileMenuShowBodyBlock").removeClass("showAutoComplete");
			$("#recentlySearchWord").removeClass("showAutoComplete");
			$("#recentlySearch").removeClass("showAutoComplete");
		},
		focus: function(event, ui) {
			var autocompleteArea = $("." + autoCompleteClass);
			autocompleteArea.find("li").removeClass("focus");
			var menu = autocompleteArea.find(".ui-state-active");
			menu.parent().addClass("focus");
		}
	});
};
//autocomplete menu search end

var MobilelockBodyScroll = function(type) {
	switch (type) {
	case "lock":
		$("body").addClass("lockscroll");
		break;
	case "unlock":
		$("body").removeClass("lockscroll");
		break;
	}
};

var checkSearch = function(tipword) {
	var keyWord = $("#full-search-keyword").val().trim();
	if (keyWord.length >= 2) {
		setRecentlySearch(keyWord);
		//SendGaEvent("Top-Menu-Search", keyWord, location.pathname + location.search);
		return true;
	} else {
		if ($("#header-bar").find(".content-other").find(".menuSearchToolTip").length > 0) {
			$("#header-bar").find(".content-other").find(".menuSearchToolTip").remove();
		}
		var headerOther = $("#header-bar").find(".content-other");
		var tip = $(".toolTipAreaSample").clone();
		tip.addClass("menuSearchToolTip");
		headerOther.append(tip);
		var tipObj = $("#header-bar").find(".content-other").find(".menuSearchToolTip");
		tipObj.removeClass("openMobileSearch");
		if ($("#header-bar").hasClass("opensearch") && CheckUseRWDsizeNow()) {
			tipObj.addClass("openMobileSearch");
		}

		tipObj.find("p.innerTxt").html(tipword);
		tipObj.css("opacity", 0);
		tipObj.removeClass("hide");
		tipObj.animate({
				opacity: 1
			},
			200);

		setTimeout(function() {
				tipObj.animate({
						opacity: 0
					},
					200,
					function() {
						tipObj.remove();
					});
				//$("#full-search-keyword").tooltip().tooltip("close");
				//$("#full-search-keyword").attr("title", "");
			},
			2000);
		return false;
	}

};
var setRecentlySearch = function(key) {
	var code = Utf8ToUnicode(key);
	var CookieRecord = [];
	var cookie = CookieWithCountryCode.get("SearchRecord");
	var maxItem = 5;
	CookieRecord.push(code);
	if (cookie && cookie !== "") {
		var cookieJson = JSON.parse(cookie);
		var cookieJsonLength = cookieJson.length;
		for (var i = 0; i < cookieJsonLength; i++) {
			var word = cookieJson[i];
			if (!jsonEqual(word, code)) {
				CookieRecord.push(word);
			}
			if ((i + 1) === cookieJsonLength || ((CookieRecord.length) === maxItem)) {
				setCookieRecentlySearch(CookieRecord);
				break;
			}
		}
	} else {
		setCookieRecentlySearch(CookieRecord);
	}
};

var GetRecentlySearchItem = function() {
	var cookie = CookieWithCountryCode.get("SearchRecord");
	var record = [];
	if (cookie && cookie !== "") {
		var cookieJson = JSON.parse(cookie);
		var cookieJsonLength = cookieJson.length;
		for (var i = 0; i < cookieJsonLength; i++) {
			record.push(UnicodeToUtf8(cookieJson[i]));
			if ((i + 1) === cookieJsonLength) {
				settingRecentlySearchItem(record);
			}
		}
	}
};

var settingRecentlySearchItem = function(record) {
	var area = $("#recentlySearch");
	var tipWord = $("#recentlySearchWord");
	tipWord.removeClass("show");
	area.removeClass("show");
	var recordLength = record.length;
	area.html("");
	if (recordLength > 0) {
		var li = $("<li></li>");
		li.addClass("itemRecently");
		//li.addClass("google-font");
		var lispan = $("<span></span>");
		lispan.addClass("text");
		lispan.append($("#recentlySearchWord").text());
		li.append(lispan);
		area.append(li);
	}
	for (var i = 0; i < recordLength; i++) {
		var item = $("<li></li>");
		item.addClass("item");
		//item.addClass("google-font");
		var span = $("<span></span>");
		span.addClass("text");
		span.append(record[i]);
		item.append(span);
		var word = record[i];
		if (word) {
			word = escape(word);
		}
		item.attr("onclick", "clickRecntlySearch('" + word + "')");
		area.append(item);
		if ((i + 1) === recordLength) {
			area.addClass("show");
			tipWord.addClass("show");
			area.find("li.item").on({
				'touchstart': function() {
					$(this).addClass("active");
				}
			}).on({
				'touchend': function() {
					$(this).removeClass("active");
				}
			});
		}
	}
};

var clickRecntlySearch = function(word) {
	if (word) {
		word = unescape(word);
	}
	$("#full-search-keyword").val(word);
	$("#full-search-keyword").trigger("focus");
	//SendGaEvent("Top-Menu", "click-recentlySearch:" + word, location.pathname + location.search + location.hash);
	checkSearWordToClear();
};

var setCookieRecentlySearch = function(obj) {
	CookieWithCountryCode.set("SearchRecord", JSON.stringify(obj), "false", 30);
};
//////Layout use Header script end----------------------------------

var showMobileMenu = function(that) {
	var titleId = that.attr("data-titleid");
	var menuObj = that.find("ul.menu-body-area-for-title-" + titleId);
	var mobileMenuShowBodyArea = $("#mobileMenuShowBodyBlock");
	if (menuObj.length > 0) {
		var btmArea = mobileMenuShowBodyArea.find(".mobileBtmMenuArea").clone();
		var bodyMenu = that.clone();
		var titleObj = bodyMenu.children("a");
		titleObj.attr("href", titleObj.attr("data-pclink"));
		mobileMenuShowBodyArea.html(bodyMenu);
		//var backFixed = mobileMenuShowBodyArea.find(".backMainPage").clone();
		//mobileMenuShowBodyArea.append(backFixed);
		//if (!btmArea.find(".mobileBtmMenu").find(".mobileBtmMenuCommon").length) {
		//	btmArea.find(".mobileBtmMenu").append($(".content-menu").find(".mobileBtmMenu li").clone());
		//}
		mobileMenuShowBodyArea.append(btmArea);
		var callBack = function() {
			mobileMenuShowBodyArea.addClass("showBody");
			$(".mobileBtmMenuBack").addClass("showOpacity");
			$("#header-bar").find(".content-menu").addClass("showBody");
			$("#PageMainContentBlock").addClass("whiteBg");
			settingMenuBodyScroll();
			setMenuFadeOutButton();
		};
		setMobileMenuAnimation("showMenuBody", callBack);
	}
};

var settingMenuBodyScroll = function() {
	var bodyArea = $("#mobileMenuShowBodyBlock");
	var minHeight = parseInt(bodyArea.css("min-height"));
	var realHeight = bodyArea.find("li.menuTitle").height() + (bodyArea.find("li.mobileBtmMenuArea").height() / 2);
	if (realHeight > minHeight) {
		bodyArea.find("li.backMainPage").addClass("show");
		$("#header-bar").on("scroll",
			function() {
				//var scroll = $("#header-bar").scrollTop();
				var policyHeight = 0;
				if ($("#policy-div").height() > 0 && !$("#policy-div").hasClass("scrolling")) {
					//policyHeight = $("#policy-div").height();
				}
				var scroll = bodyArea.find(".mobileBtmMenuArea").offset().top +
					60 +
					policyHeight -
					$("#header-bar").offset().top;
				if (scroll < $("#header-bar").height()) {
					bodyArea.find("li.backMainPage").removeClass("show");
				} else {
					bodyArea.find("li.backMainPage").addClass("show");
				}
			});
	}

};